[
  {
    "name": "United Arab Emirates Dirham",
    "nameFr": "Dirham des Emirats Arabes Unis",
    "code": "AED",
    "symbol": "د.إ"
  },
  {
    "name": "Albanian Lek",
    "nameFr": "Lek albanais",
    "code": "ALL",
    "symbol": "L"
  },
  {
    "name": "Barbadian Dollar",
    "nameFr": "Dollar barbadien",
    "code": "BBD",
    "symbol": "$"
  },
  {
    "name": "Belize Dollar",
    "nameFr": "Dollar bélizien",
    "code": "BZD",
    "symbol": "BZ$"
  },
  {
    "name": "Chinese Yuan",
    "nameFr": "Yuan chinois",
    "code": "CNY",
    "symbol": "¥"
  },
  {
    "name": "Colombian Peso",
    "nameFr": "Peso colombien",
    "code": "COP",
    "symbol": "$"
  },
  {
    "name": "Czech Republic Koruna",
    "nameFr": "Couronne de la République tchèque",
    "code": "CZK",
    "symbol": "Kč"
  },
  {
    "name": "Danish Krone",
    "nameFr": "Couronne danoise",
    "code": "DKK",
    "symbol": "kr"
  },
  {
    "name": "Falkland Islands Pound",
    "nameFr": "Livre des îles Falkland",
    "code": "FKP",
    "symbol": "£"
  },
  {
    "name": "Guatemalan Quetzal",
    "nameFr": "Quetzal guatémaltèque",
    "code": "GTQ",
    "symbol": "Q"
  },
  {
    "name": "Croatian Kuna",
    "nameFr": "Kuna croate",
    "code": "HRK",
    "symbol": "kn"
  },
  {
    "name": "Indonesian Rupiah",
    "nameFr": "Roupie indonésienne",
    "code": "IDR",
    "symbol": "Rp"
  },
  {
    "name": "Iranian Rial",
    "nameFr": "Rial iranien",
    "code": "IRR",
    "symbol": "﷼"
  },
  {
    "name": "Japanese Yen",
    "nameFr": "Yen japonais",
    "code": "JPY",
    "symbol": "¥"
  },
  {
    "name": "Cambodian Riel",
    "nameFr": "Riel cambodgien",
    "code": "KHR",
    "symbol": "៛"
  },
  {
    "name": "Lesotho Loti",
    "nameFr": "Lesotho Loti",
    "code": "LSL",
    "symbol": "M"
  },
  {
    "name": "Libyan Dinar",
    "nameFr": "Dinar libyen",
    "code": "LYD",
    "symbol": "LD"
  },
  {
    "name": "Mauritian Rupee",
    "nameFr": "Roupie mauricienne",
    "code": "MUR",
    "symbol": "₨"
  },
  {
    "name": "Malaysian Ringgit",
    "nameFr": "Ringgit malaisien",
    "code": "MYR",
    "symbol": "RM"
  },
  {
    "name": "Nicaraguan Córdoba",
    "nameFr": "Nicaraguayen Córdoba",
    "code": "NIO",
    "symbol": "C$"
  },
  {
    "name": "Papua New Guinean Kina",
    "nameFr": "Kina de Papouasie-Nouvelle-Guinée",
    "code": "PGK",
    "symbol": "K"
  },
  {
    "name": "Pakistani Rupee",
    "nameFr": "Roupie pakistanaise",
    "code": "PKR",
    "symbol": "₨"
  },
  {
    "name": "Qatari Rial",
    "nameFr": "Rial qatari",
    "code": "QAR",
    "symbol": "﷼"
  },
  {
    "name": "Singapore Dollar",
    "nameFr": "Dollar de Singapour",
    "code": "SGD",
    "symbol": "$"
  },
  {
    "name": "Sierra Leonean Leone",
    "nameFr": "Sierra Leonean Leone",
    "code": "SLL",
    "symbol": "Le"
  },
  {
    "name": "São Tomé and Príncipe Dobra (pre-2018)",
    "nameFr": "São Tomé et Príncipe Dobra (avant 2018)",
    "code": "STD",
    "symbol": "Db"
  },
  {
    "name": "Tunisian Dinar",
    "nameFr": "Dinar tunisien",
    "code": "TND",
    "symbol": "د.ت"
  },
  {
    "name": "Trinidad and Tobago Dollar",
    "nameFr": "Dollar de Trinité-et-Tobago",
    "code": "TTD",
    "symbol": "TT$"
  },
  {
    "name": "New Taiwan Dollar",
    "nameFr": "Nouveau dollar de Taïwan",
    "code": "TWD",
    "symbol": "NT$"
  },
  {
    "name": "Ugandan Shilling",
    "nameFr": "Shilling ougandais",
    "code": "UGX",
    "symbol": "USh"
  },
  {
    "name": "Samoan Tala",
    "nameFr": "Samoan Tala",
    "code": "WST",
    "symbol": "WS$"
  },
  {
    "name": "Zambian Kwacha",
    "nameFr": "Kwacha zambien",
    "code": "ZMW"
  },
  {
    "name": "Argentine Peso",
    "nameFr": "Peso argentin",
    "code": "ARS",
    "symbol": "$"
  },
  {
    "name": "Bangladeshi Taka",
    "nameFr": "Bangladeshi Taka",
    "code": "BDT",
    "symbol": "৳"
  },
  {
    "name": "Bermudan Dollar",
    "nameFr": "Dollar des Bermudes",
    "code": "BMD",
    "symbol": "$"
  },
  {
    "name": "Bolivian Boliviano",
    "nameFr": "Boliviano bolivien",
    "code": "BOB",
    "symbol": "$b"
  },
  {
    "name": "Botswanan Pula",
    "nameFr": "Pula du Botswana",
    "code": "BWP",
    "symbol": "P"
  },
  {
    "name": "Chilean Peso",
    "nameFr": "Peso chilien",
    "code": "CLP",
    "symbol": "$"
  },
  {
    "name": "Cuban Peso",
    "nameFr": "Peso Cubain",
    "code": "CUP",
    "symbol": "₱"
  },
  {
    "name": "Cape Verdean Escudo",
    "nameFr": "Escudo du Cap-Vert",
    "code": "CVE",
    "symbol": "$"
  },
  {
    "name": "Algerian Dinar",
    "nameFr": "Dinar algérien",
    "code": "DZD",
    "symbol": "دج"
  },
  {
    "name": "Egyptian Pound",
    "nameFr": "Livre égyptienne",
    "code": "EGP",
    "symbol": "£"
  },
  {
    "name": "Hong Kong Dollar",
    "nameFr": "Dollar de Hong Kong",
    "code": "HKD",
    "symbol": "$"
  },
  {
    "name": "Haitian Gourde",
    "nameFr": "Gourde haïtienne",
    "code": "HTG",
    "symbol": "G"
  },
  {
    "name": "Indian Rupee",
    "nameFr": "Roupie indienne",
    "code": "INR",
    "symbol": "₹"
  },
  {
    "name": "Jordanian Dinar",
    "nameFr": "Dinar jordanien",
    "code": "JOD",
    "symbol": "JD"
  },
  {
    "name": "Lebanese Pound",
    "nameFr": "Livre libanaise",
    "code": "LBP",
    "symbol": "£"
  },
  {
    "name": "Liberian Dollar",
    "nameFr": "Dollar libérien",
    "code": "LRD",
    "symbol": "$"
  },
  {
    "name": "Moroccan Dirham",
    "nameFr": "Dirham marocain",
    "code": "MAD",
    "symbol": "MAD"
  },
  {
    "name": "Macedonian Denar",
    "nameFr": "Denar macédonien",
    "code": "MKD",
    "symbol": "ден"
  },
  {
    "name": "Mongolian Tugrik",
    "nameFr": "Tugrik mongol",
    "code": "MNT",
    "symbol": "₮"
  },
  {
    "name": "Nigerian Naira",
    "nameFr": "Naira nigérian",
    "code": "NGN",
    "symbol": "₦"
  },
  {
    "name": "Panamanian Balboa",
    "nameFr": "Balboa panaméen",
    "code": "PAB",
    "symbol": "B/."
  },
  {
    "name": "Polish Zloty",
    "nameFr": "Zloty polonais",
    "code": "PLN",
    "symbol": "zł"
  },
  {
    "name": "Romanian Leu",
    "nameFr": "Leu roumain",
    "code": "RON",
    "symbol": "lei"
  },
  {
    "name": "Rwandan Franc",
    "nameFr": "Franc rwandais",
    "code": "RWF",
    "symbol": "R₣"
  },
  {
    "name": "Saint Helena Pound",
    "nameFr": "Livre de Sainte-Hélène",
    "code": "SHP",
    "symbol": "£"
  },
  {
    "name": "Somali Shilling",
    "nameFr": "Shilling somalien",
    "code": "SOS",
    "symbol": "S"
  },
  {
    "name": "Salvadoran Colón",
    "nameFr": "Colon salvadorien",
    "code": "SVC",
    "symbol": "$"
  },
  {
    "name": "Tongan Pa'anga",
    "nameFr": "Tongan Pa'anga",
    "code": "TOP",
    "symbol": "T$"
  },
  {
    "name": "United States Dollar",
    "nameFr": "Dollar des États-Unis",
    "code": "USD",
    "symbol": "$"
  },
  {
    "name": "Uzbekistan Som",
    "nameFr": "Ouzbékistan Som",
    "code": "UZS",
    "symbol": "лв"
  },
  {
    "name": "Venezuelan Bolívar Fuerte (Old)",
    "nameFr": "Vénézuélien Bolívar Fuerte (ancien)",
    "code": "VEF",
    "symbol": "Bs"
  },
  {
    "name": "Vietnamese Dong",
    "nameFr": "Dong vietnamien",
    "code": "VND",
    "symbol": "₫"
  },
  {
    "name": "South African Rand",
    "nameFr": "Rand sud-africain",
    "code": "ZAR",
    "symbol": "R"
  },
  {
    "name": "Netherlands Antillean Guilder",
    "nameFr": "florin des Antilles néerlandaises",
    "code": "ANG",
    "symbol": "ƒ"
  },
  {
    "name": "Australian Dollar",
    "nameFr": "Dollar australien",
    "code": "AUD",
    "symbol": "$"
  },
  {
    "name": "Bulgarian Lev",
    "nameFr": "Lev bulgare",
    "code": "BGN",
    "symbol": "лв"
  },
  {
    "name": "Burundian Franc",
    "nameFr": "Franc burundais",
    "code": "BIF",
    "symbol": "FBu"
  },
  {
    "name": "Brunei Dollar",
    "nameFr": "Dollar brunéien",
    "code": "BND",
    "symbol": "$"
  },
  {
    "name": "Bahamian Dollar",
    "nameFr": "Dollar des Bahamas",
    "code": "BSD",
    "symbol": "$"
  },
  {
    "name": "Bhutanese Ngultrum",
    "nameFr": "Ngultrum bhoutanais",
    "code": "BTN",
    "symbol": "Nu."
  },
  {
    "name": "Belarusian Ruble",
    "nameFr": "Rouble biélorusse",
    "code": "BYN",
    "symbol": "Br"
  },
  {
    "name": "Swiss Franc",
    "nameFr": "Franc suisse",
    "code": "CHF",
    "symbol": "CHF"
  },
  {
    "name": "Djiboutian Franc",
    "nameFr": "Franc Djiboutien",
    "code": "DJF",
    "symbol": "Fdj"
  },
  {
    "name": "Dominican Peso",
    "nameFr": "Peso dominicain",
    "code": "DOP",
    "symbol": "RD$"
  },
  {
    "name": "Ethiopian Birr",
    "nameFr": "birr éthiopien",
    "code": "ETB",
    "symbol": "Br"
  },
  {
    "name": "Euro",
    "nameFr": "Euro",
    "code": "EUR",
    "symbol": "€"
  },
  {
    "name": "Fijian Dollar",
    "nameFr": "Dollar fidjien",
    "code": "FJD",
    "symbol": "$"
  },
  {
    "name": "Ghanaian Cedi",
    "nameFr": "Cedi ghanéen",
    "code": "GHS",
    "symbol": "GH₵"
  },
  {
    "name": "Gambian Dalasi",
    "nameFr": "Dalasi gambien",
    "code": "GMD",
    "symbol": "D"
  },
  {
    "name": "Guyanaese Dollar",
    "nameFr": "Dollar guyanais",
    "code": "GYD",
    "symbol": "$"
  },
  {
    "name": "Honduran Lempira",
    "nameFr": "Lempira hondurien",
    "code": "HNL",
    "symbol": "L"
  },
  {
    "name": "Israeli New Sheqel",
    "nameFr": "Nouveau shekel israélien",
    "code": "ILS",
    "symbol": "₪"
  },
  {
    "name": "South Korean Won",
    "nameFr": "Won sud-coréen",
    "code": "KRW",
    "symbol": "₩"
  },
  {
    "name": "Kuwaiti Dinar",
    "nameFr": "Dinar koweïtien",
    "code": "KWD",
    "symbol": "KD"
  },
  {
    "name": "Kazakhstani Tenge",
    "nameFr": "Tenge kazakh",
    "code": "KZT",
    "symbol": "лв"
  },
  {
    "name": "Sri Lankan Rupee",
    "nameFr": "Roupie sri lankaise",
    "code": "LKR",
    "symbol": "₨"
  },
  {
    "name": "Macanese Pataca",
    "nameFr": "Pataca macanaise",
    "code": "MOP",
    "symbol": "MOP$"
  },
  {
    "name": "Maldivian Rufiyaa",
    "nameFr": "Rufiyaa des Maldives",
    "code": "MVR",
    "symbol": "Rf"
  },
  {
    "name": "Malawian Kwacha",
    "nameFr": "Kwacha malawien",
    "code": "MWK",
    "symbol": "MK"
  },
  {
    "name": "Mexican Peso",
    "nameFr": "Peso mexicain",
    "code": "MXN",
    "symbol": "$"
  },
  {
    "name": "Namibian Dollar",
    "nameFr": "Dollar namibien",
    "code": "NAD",
    "symbol": "$"
  },
  {
    "name": "Norwegian Krone",
    "nameFr": "Couronne norvégienne",
    "code": "NOK",
    "symbol": "kr"
  },
  {
    "name": "Nepalese Rupee",
    "nameFr": "Roupie népalaise",
    "code": "NPR",
    "symbol": "₨"
  },
  {
    "name": "Peruvian Nuevo Sol",
    "nameFr": "Nuevo Sol péruvien",
    "code": "PEN",
    "symbol": "S/."
  },
  {
    "name": "Philippine Peso",
    "nameFr": "Peso philippin",
    "code": "PHP",
    "symbol": "₱"
  },
  {
    "name": "Paraguayan Guarani",
    "nameFr": "Guarani paraguayen",
    "code": "PYG",
    "symbol": "Gs"
  },
  {
    "name": "Russian Ruble",
    "nameFr": "Rouble russe",
    "code": "RUB",
    "symbol": "₽"
  },
  {
    "name": "Solomon Islands Dollar",
    "nameFr": "Dollar des îles Salomon",
    "code": "SBD",
    "symbol": "$"
  },
  {
    "name": "Seychellois Rupee",
    "nameFr": "Roupie seychelloise",
    "code": "SCR",
    "symbol": "₨"
  },
  {
    "name": "Swedish Krona",
    "nameFr": "couronne suédoise",
    "code": "SEK",
    "symbol": "kr"
  },
  {
    "name": "Thai Baht",
    "nameFr": "Thai Baht",
    "code": "THB",
    "symbol": "฿"
  },
  {
    "name": "Turkish Lira",
    "nameFr": "Lire turque",
    "code": "TRY",
    "symbol": "₺"
  },
  {
    "name": "Tanzanian Shilling",
    "nameFr": "Shilling tanzanien",
    "code": "TZS",
    "symbol": "TSh"
  },
  {
    "name": "Uruguayan Peso",
    "nameFr": "Peso uruguayen",
    "code": "UYU",
    "symbol": "$U"
  },
  {
    "name": "Vanuatu Vatu",
    "nameFr": "Vanuatu Vatu",
    "code": "VUV",
    "symbol": "VT"
  },
  {
    "name": "CFA Franc BCEAO",
    "nameFr": "Franc CFA BCEAO",
    "code": "XOF",
    "symbol": "CFA"
  },
  {
    "name": "Aruban Florin",
    "nameFr": "Aruba Florin",
    "code": "AWG",
    "symbol": "ƒ"
  },
  {
    "name": "Bahraini Dinar",
    "nameFr": "Dinar bahreïni",
    "code": "BHD",
    "symbol": ".د.ب"
  },
  {
    "name": "Canadian Dollar",
    "nameFr": "Dollar canadien",
    "code": "CAD",
    "symbol": "$"
  },
  {
    "name": "Costa Rican Colón",
    "nameFr": "Costa Rica Colón",
    "code": "CRC",
    "symbol": "₡"
  },
  {
    "name": "British Pound Sterling",
    "nameFr": "Livre sterling",
    "code": "GBP",
    "symbol": "£"
  },
  {
    "name": "Guinean Franc",
    "nameFr": "franc guinéen",
    "code": "GNF",
    "symbol": "FG"
  },
  {
    "name": "Hungarian Forint",
    "nameFr": "Forint hongrois",
    "code": "HUF",
    "symbol": "Ft"
  },
  {
    "name": "Iraqi Dinar",
    "nameFr": "Dinar irakien",
    "code": "IQD",
    "symbol": "ع.د"
  },
  {
    "name": "Icelandic Króna",
    "nameFr": "couronne islandaise",
    "code": "ISK",
    "symbol": "kr"
  },
  {
    "name": "Kenyan Shilling",
    "nameFr": "Kenyan Shilling",
    "code": "KES",
    "symbol": "KSh"
  },
  {
    "name": "Kyrgystani Som",
    "nameFr": "Som kirghize",
    "code": "KGS",
    "symbol": "лв"
  },
  {
    "name": "Comorian Franc",
    "nameFr": "Franc comorien",
    "code": "KMF",
    "symbol": "CF"
  },
  {
    "name": "North Korean Won",
    "nameFr": "Won nord-coréen",
    "code": "KPW",
    "symbol": "₩"
  },
  {
    "name": "Cayman Islands Dollar",
    "nameFr": "Dollar des îles Caïmans",
    "code": "KYD",
    "symbol": "$"
  },
  {
    "name": "Laotian Kip",
    "nameFr": "Kip laotien",
    "code": "LAK",
    "symbol": "₭"
  },
  {
    "name": "Moldovan Leu",
    "nameFr": "Leu moldave",
    "code": "MDL",
    "symbol": "lei"
  },
  {
    "name": "Myanma Kyat",
    "nameFr": "Myanma Kyat",
    "code": "MMK",
    "symbol": "K"
  },
  {
    "name": "New Zealand Dollar",
    "nameFr": "Dollar néo-zélandais",
    "code": "NZD",
    "symbol": "$"
  },
  {
    "name": "Omani Rial",
    "nameFr": "Rial omanais",
    "code": "OMR",
    "symbol": "﷼"
  },
  {
    "name": "Saudi Riyal",
    "nameFr": "Rial saoudien",
    "code": "SAR",
    "symbol": "﷼"
  },
  {
    "name": "Syrian Pound",
    "nameFr": "Livre syrienne",
    "code": "SYP",
    "symbol": "£"
  },
  {
    "name": "Ukrainian Hryvnia",
    "nameFr": "Hryvnia ukrainienne",
    "code": "UAH",
    "symbol": "₴"
  },
  {
    "name": "CFA Franc BEAC",
    "nameFr": "Franc CFA BEAC",
    "code": "XAF",
    "symbol": "FCFA"
  },
  {
    "name": "East Caribbean Dollar",
    "nameFr": "Dollar des Caraïbes orientales",
    "code": "XCD",
    "symbol": "$"
  },
  {
    "name": "CFP Franc",
    "nameFr": "Franc CFP",
    "code": "XPF",
    "symbol": "₣"
  },
  {
    "name": "Yemeni Rial",
    "nameFr": "Rial yéménite",
    "code": "YER",
    "symbol": "﷼"
  }
]
